module.exports = __webpack_public_path__ + "img/potencia_c_blue.97a22eed.svg";